import { useLocation, useParams } from 'react-router-dom'
import { UserOrgDetails } from '../UserOrgDetails/UserOrgDetails'

export function UserOrgDetailsPage() {
  const { pathname } = useLocation()
  const { userId } = useParams()

  const isAdmin = pathname.includes('admin')

  if (!userId) {
    return null
  }

  return <UserOrgDetails userId={Number(userId)} isAdmin={isAdmin} />
}
